<template>
    <div>
        <zm-row>
            <zm-button size="small" @click="showCreate()" class="btn-in-line" type="primary" v-if="hasPermission">Create Alert</zm-button>
            <zm-button size="small" @click="fetchData(true)" plain class="btn-in-line">show all</zm-button>
            <zm-select size="small" v-model="channelId" @change="fetchData"
            placeholder="Search by channel" class="channel-select" clearable filterable>
                <zm-option v-for="item in channelList" :key="item.channelId"
                :label="item.channelName" :value="item.channelId"></zm-option>
            </zm-select>
        </zm-row>
        <zm-table :data="list" v-loading="loading">
            <zm-table-column prop="name" label="name"></zm-table-column>
            <zm-table-column prop="channelName" label="channelName"></zm-table-column>
            <zm-table-column prop="alertEmail" label="alertEmail"></zm-table-column>
            <zm-table-column prop="alertType" label="alertType" width="140px" show-overflow-tooltip></zm-table-column>
            <zm-table-column prop="threshold" label="threshold" width="100px"></zm-table-column>
            <zm-table-column prop="group" label="group" show-overflow-tooltip></zm-table-column>
            <zm-table-column prop="webhookChannels" label="webhookChannels" show-overflow-tooltip :formatter="setWebhook">
            </zm-table-column>
            <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime"></zm-table-column>
            <zm-table-column width="100px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="deleteAlert(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <zm-dialog :title="!form.id ? 'Create Alert' : 'Edit Alert'" :visible.sync="visible">
            <zm-form :model="form" :rules="rules" label-position="left" ref="form" label-width="150px">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="name" id="manage-alert-name"></tip>
                    </div>
                    <zm-input size="small" v-model="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="alertEmail">
                    <div slot="label">
                        <tip label="alertEmail" id="manage-alert-alertEmail"></tip>
                    </div>
                    <zm-input size="small" v-model="form.alertEmail" placeholder="san.zhang@zoom.us,si.li@zoom.us,"></zm-input>
                </zm-form-item>
                <zm-form-item prop="alertType">
                    <div slot="label">
                        <tip label="alertType" id="manage-alert-alertType"></tip>
                    </div>
                    <zm-select size="small" v-model="form.alertType">
                        <zm-option label="GROUP_LAG" value="GROUP_LAG"></zm-option>
                        <zm-option label="CLUSTER_STATE" value="CLUSTER_STATE"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="channelId">
                    <div slot="label">
                        <tip label="channelId" id="manage-alert-channelId"></tip>
                    </div>
                    <zm-select size="small" v-model="form.channelId" @change="fetchGroup" style="width: 100%">
                        <zm-option v-for="item in channelList" :key="item.channelId"
                        :label="item.channelName" :value="item.channelId"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="group">
                    <div slot="label">
                        <tip label="group" id="manage-alert-group"></tip>
                    </div>
                    <zm-select size="small" v-model="form.group" filterable clearable allow-create style="width: 100%">
                        <zm-option v-for="item in groupList" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item prop="threshold">
                    <div slot="label">
                        <tip label="threshold" id="manage-alert-threshold"></tip>
                    </div>
                    <zm-input-number size="small" v-model="form.threshold" :min="0"></zm-input-number>
                </zm-form-item>
                <zm-form-item prop="webhookAlertIds">
                    <div slot="label">
                        <tip label="webhookAlertIds" id="manage-alert-webhookAlertIds"></tip>
                    </div>
                    <zm-select size="small" v-model="form.webhookAlertIds" multiple filterable style="width: 100%">
                        <zm-option v-for="item in webhookList" :key="item.id" :value="item.id" :label="item.name"></zm-option>
                    </zm-select>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="visible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Save</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { listCluster, getClusterGroups } from '@/api/kafkaManage'
import { listAlert, createAlert, updateAlert, deleteAlert, listWebhook, listAlertByChannel } from '@/api/manage'
import tip from 'components/ToolTip/index'
export default {
    name: 'manageAlert',
    components: {
        tip
    },
    data () {
        var validateEmail = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('please enter email'))
            } else {
                const emails = value.split(',')
                for (var item in emails) {
                    var apos = emails[item].indexOf('@')
                    var lastapos = emails[item].lastIndexOf('@')
                    var dotpos = emails[item].lastIndexOf('.')
                    if ((apos < 1 || dotpos - apos < 2 || apos !== lastapos) && emails[item] !== '') {
                        callback(new Error('invalid emails!'))
                    }
                }
                callback()
            }
        }
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            loading: false,
            list: [],
            channelList: [],
            groupList: [],
            webhookList: [],
            visible: false,
            channelId: '',
            form: {
                alertEmail: '',
                alertType: 'CLUSTER_STATE',
                channelId: '',
                group: '',
                id: '',
                name: '',
                threshold: 0,
                webhookAlertIds: []
            },
            rules: {
                name: [
                    { required: true, message: 'please enter name', trigger: 'blur' }
                ],
                alertEmail: [
                    { required: true, validator: validateEmail, trigger: 'blur' }
                ],
                alertType: [
                    { required: true, message: 'please enter alertType', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
        this.fetchChannel()
        this.fetchWebhook()
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    methods: {
        setTime (row, column, cellValue, index) {
            return new Date(parseInt(cellValue)).toLocaleString()
        },
        setWebhook (row, column, cellValue, index) {
            if (cellValue && cellValue.length) {
                return cellValue.map(item => {
                    return item.name
                }).join()
            }
            return ''
        },
        showAll () {
            this.listBy = 0
            this.fetchData()
        },
        fetchData (showAll) {
            if (showAll === true) {
                this.channelId = ''
            }
            if (!this.channelId) {
                this.loading = true
                listAlert().then(response => {
                    this.loading = false
                    this.list = response
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.loading = true
                listAlertByChannel(this.channelId).then(response => {
                    this.loading = false
                    this.list = response
                }).catch(() => {
                    this.loading = false
                })
            }
        },
        fetchChannel () {
            listCluster().then(res => {
                this.channelList = res
            })
        },
        fetchWebhook () {
            listWebhook().then(res => {
                this.webhookList = res
            })
        },
        fetchGroup () {
            if (this.form.channelId) {
                getClusterGroups(this.form.channelId).then(res => {
                    this.groupList = res.groupIds
                })
            } else {
                this.groupList = []
            }
        },
        deleteAlert (id) {
            this.$confirm('This will delete the alert. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteAlert(id).then(response => {
                    this.fetchData()
                    this.$message({
                        message: 'Delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        showCreate () {
            this.form.id = ''
            this.form.name = ''
            this.form.alertEmail = ''
            this.form.alertType = ''
            this.form.channelId = ''
            this.form.group = ''
            this.form.threshold = ''
            this.form.webhookAlertIds = []
            this.visible = true
        },
        showEdit (row) {
            this.form.id = row.id
            this.form.name = row.name
            this.form.alertEmail = row.alertEmail
            this.form.alertType = row.alertType
            this.form.channelId = row.channelId
            this.form.group = row.group
            this.form.threshold = row.threshold
            this.form.webhookAlertIds = []
            if (row.webhookChannels && row.webhookChannels.length) {
                this.form.webhookAlertIds = row.webhookChannels.map(item => {
                    return item.id
                })
            }
            this.visible = true
        },
        save () {
            this.loading = true
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (!this.form.id) {
                        createAlert(this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Create success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        updateAlert(this.form).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Edit success!',
                                type: 'success'
                            })
                            this.visible = false
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                } else {
                    this.loading = false
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        }
    }
}
</script>
<style scoped>
.channel-select {
    float: right;
    margin: 10px;
    width: 20%;
}
</style>
